




































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
// import firebase from 'firebase/app';
// import 'firebase/auth';
import {logout} from '@/api';

@Component
export default class Header extends Vue {
    private title = '三行感想文';

    @Prop() private propIsOpen!: boolean;
    private isOpen: boolean = this.propIsOpen;

    @Watch('propIsOpen')
    private onValueChange(newValue: boolean, oldValue: boolean): void {
        this.isOpen = newValue;
    }

    private logout() {
        logout();
    }

    private closeDrawer() {
        this.isOpen = !this.isOpen;
        this.$emit('closeDrawer', this.isOpen);
    }
}
